
<!-- [class]="option?.isSelected ? 'app__discovery-option-form-selected ' : 'app__discovery-option-form'" -->

<h2>Bulk upload review</h2>
<div class="m-0 text-lg text-[#53565b] flex items-start flex-col">   
    <!-- <p>Do you want to add <span class="font-bold text-k-blue">{{data.form_name }}</span> right now?</p> -->


    {{ data.action_label }}
  </div>





<mat-divider class="mat-divider m-0 sm:mb-6 sm:mt-[42px]" aria-orientation="horizontal"></mat-divider>

<div class="flex items-start justify-between pl-0 pr-0 w-full h-[65px] mt-4">
    <button class="bg-transparent cursor-pointer flex items-center font-bold text-xs gap-2" (click)="back()">
      <span class="flex items-center gap-2 text-[#18191C]"
        ><span class="material-icons text-base"> arrow_back</span> <span class="text-sm font-semibold"> Back</span></span
      >
    </button>
    <div class="w-[158px]">
      <button type="submit" (click)="save()" class="app__btn--primary mt-0">Continue</button>
    </div>
  </div>
  


